// THE PAYMENTS COPY, APPROVED by the Founder (Daniel, 2026-10-21):
// docs/i18n/copy-review-payments-2026-10-16.csv, pinned by
// i18n/copyReviewPayments.test.ts. English as proposed (his English column is
// blank: accepted). For the payments FLIP release only: this track ships when
// PAYMENTS_ENABLED does, not before (Web Director).
//
// ONLY THE WORDS ENTRY CODE SAYS (W6 step 2, the pay-string split; Web
// Director, 2026-10-20): Review's pay line and button, the waiting line that
// Review and the guest steps show, and the pointer a pay screen falls back to
// when its chunk cannot load (views/Book/PayChunkFallback.tsx: words a failed
// chunk cannot bring). Every other pay.* and refund.* word is
// in ./payScreens.ts, which the lazy pay chunks register before they render
// (i18n/payScreenMessages.ts).

export const en = {
  "pay.review.button": "Continue to payment",
  // Review's pay card title for an INSTANT business that takes the full price at
  // booking (sheet 3, 2026-10-29: Daniel's English; was sheet 2's "Pay when you book").
  "pay.review.cardTitle": "Payment due now",
  "pay.review.depositLine": "You'll pay a {amount} deposit now on Stripe's secure page. The rest is due at your appointment.",
  "pay.review.fullLine": "You'll pay {amount} now on Stripe's secure page.",
  "pay.return.waiting": "We're still confirming your payment. We'll email you when it's done.",
  "pay.return.otherBrowser": "Check your email or your appointment link for the result of your payment. You can close this page.",
  // Sheet 3, APPROVED (Daniel, 2026-10-29; docs/i18n/copy-review-payments-3-2026-10-29.csv): the Dev window's fixes.
  "pay.review.depositTitle": "Deposit due now",
  "pay.review.requestDepositTitle": "Deposit due after approval",
  "pay.review.requestFullTitle": "Payment due after approval",
  "pay.review.requestDepositLine": "This is a request. If {business} accepts, you'll pay {amount} to confirm. The rest is due at your appointment.",
  "pay.review.requestFullLine": "This is a request. If {business} accepts, you'll pay {amount} to confirm.",
  "pay.review.neutralTitle": "Payment to confirm",
  "pay.review.neutralLine": "A payment of {amount} is needed to confirm this booking.",
  "flow.outcome.depositAfterAccept": "{amount} deposit due after {business} accepts",
  "flow.outcome.fullAfterAccept": "{amount} due after {business} accepts",
  // Sheet 4, APPROVED (Daniel, 2026-10-31; docs/i18n/copy-review-payments-4-2026-10-31.csv): the Dev re-check.
  "pay.review.depositTotal": "Total · {price}",
} as const;
